export default __webpack_public_path__ + "static/media/launch.11e2fc30.svg";